import {AxiosServer, AxiosEsb,ArrRemoveSubItem} from '../../utils';
import {message} from 'antd';

let namespace = 'derOrderpending_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

const derOrderPendingAc = {
	SET:(value) =>(dispatch,getState)=>{
		dispatch({type: namespace+'forcedUpdate', payload: value})},		

	GET:(value)=>(dispatch,getState)=>{
		
		let store =getState().derOrderPendingRd;
		let {dataFetchProps,pagination} =store;
		let {current:currentPage,pageSize} =pagination;
		dataFetchProps ={...dataFetchProps,...value,currentPage,pageSize}
		
		let Axios = AxiosServer();
		return Axios.post('/derOrder/findAll',dataFetchProps).then((res)=>{
							
			if (res.data.status == true){				
				pagination ={...pagination,total:res.data.count}
				dispatch({type: namespace+'forcedUpdate', payload: {data:res.data.data, pagination:pagination,dataLoading: false}}); // 翻页的时候，先更新 dataLoading: true
				return '刷新成功'
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
				return '刷新失败'
			}
			
		}).catch((err)=>{
			message.error('orderList ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
			return '错误'
	})
	},	


	UPDATE:(value, selectedRowIndex = null)=>(dispatch,getState)=>{
		//可以多次dispatch(), value 是传过来的参数,  getState() 可获取当前store的状态	
		//dispatch({type:'login/set',payload:{loading:true}});
		//value 是传过来的参数
		//getState 可获取当前store的状态
		//强转id为数字，规免出错
		let id = parseInt(value.id);	
		let store = getState();
		let currentStore =store.derOrderPendingRd;
		let dataFetchProps =currentStore.dataFetchProps		
		let {include} =dataFetchProps		
		
		let Axios = AxiosServer();
		return  Axios.post('/derOrder/update',value).then((res)=>{
			dispatch({type:namespace+'updateDataById',payload: {dataLoading: true}});
		   return '更新成功'
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},

	// 将上传的文件保存到derOrderFile表。
	TOFILE:(value)=>(dispatch,getState)=>{
		let Axios = AxiosServer();
		return  Axios.post('/derOrderFile/create',value).then((res)=>{

			//更新成功，重新获取数据
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
			return '上传成功';
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},
	// 将上传的文件更新到purOrderFile表。
	UPDATEFILE:(value)=>(dispatch,getState)=>{
		let Axios = AxiosServer();
		return  Axios.post('/derOrderFile/update',value).then((res)=>{

			//更新成功，重新获取数据
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
			return '上传成功';
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},
	ESBTOSFTP:(id)=> (dispatch,getState)=>{

		let Axios = AxiosEsb();

		return  Axios.post('/api/towxsbank/der/sendToSftp',{id:id}).then((res)=>{

			//更新成功，重新获取数据
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
			return '更新成功'
		}).catch((err)=>{
			console.log('err:',err);
			return 'error'
		})

	},
	ESBTOSUBMIT:(value)=> (dispatch,getState)=>{

		let Axios = AxiosEsb();

		return  Axios.post('/api/towxsbank/submitDerOrderOtcg',{id:value.id}).then((res)=>{

			//提交成功，更新数据

			if (res.data.status){
				dispatch(derOrderPendingAc.UPDATE(value));
				//更新后台为同意
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
				return res.data.msg
			}

			return res.data.msg;


		}).catch((err)=>{
			console.log('err:',err);
			return 'error'
		})

	},

	DELETEFILE:(value)=>(dispatch,getState)=>{
		let Axios = AxiosServer();
		return  Axios.post('/derOrderFile/destroy',{id:value}).then((res)=>{

			//更新成功，重新获取数据
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
			return '上传成功';
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},
	UPDATEREMOVE:(value,selectedRowIndex)=> (dispatch,getState)=>{

		let id = parseInt(value.id);
		let Axios = AxiosServer();
		return  Axios.post('/derOrder/updateWithInclude2',value).then((res)=>{

			if (res.data.status){
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
				return '更新成功'
			}

			return '更新失败'
		}).catch((err)=>{
			dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})


	},

}


export {derOrderPendingAc};